import { ISearchResult } from '../../../state-helpers/search-results';
import * as React from 'react';
import { IEpiProps } from '../../../state-helpers/epi-props';
import { showJournalsLabel, showLabels, showPocTags, showPolicyLabel, showShopTags, showTagLabels } from './results-helpers';

interface IProps {
    result: ISearchResult;
    epiProps: IEpiProps;
}

export class SearchResultLabels extends React.Component<IProps, any> {
    render() {
        let { result, epiProps } = this.props;

        return (
            <React.Fragment>

                {showLabels(result) &&
                    <div className="search-result-labels">
                        {showPolicyLabel(result) &&
                            <span className="search-result-labels-item">
                                {epiProps.policyContextText}
                            </span>
                        }
                        {showJournalsLabel(result) &&
                            <span className="search-result-labels-item">
                                {epiProps.publicationsContextText}
                            </span>
                        }
                        {showTagLabels(result) &&
                            result.policyTopics.map(function (labelValue) {
                                return <span key={labelValue} className="search-result-labels-item">{labelValue}</span>;
                            })
                        }
                        {showPocTags(result) &&
                            result.pocTags.map(function (labelValue) {
                                return <span key={labelValue} className="search-result-labels-item">{labelValue}</span>;
                            })
                    }
                        {showShopTags(result) &&
                            result.tags.map(function (labelValue) {
                                return <span key={labelValue} className="search-result-labels-item">{labelValue}</span>;
                            })
                        }
                    </div>
                }
            </React.Fragment>
                    
            )
    }
}